module.exports = __webpack_public_path__ + "img/hotSpotCrop-256--tiny.27769c7f.png";